import type { DiamAuditAction, DiamAuditResourceType } from '../../diamApi';

export function formatAuditActionLabel(action: DiamAuditAction): string {
  switch (action) {
    case 'CREATE':
      return 'Create';
    case 'UPDATE':
      return 'Update';
    case 'DELETE':
      return 'Delete';
    default: {
      const _exhaustive: never = action;
      return _exhaustive;
    }
  }
}

export function formatAuditResourceTypeLabel(
  resourceType: DiamAuditResourceType,
): string {
  return resourceType
    .split('_')
    .map(part => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ');
}
